// Routes that render full-bleed (no centered max-width gutter): the case/order
// workspaces are three-column IGV layouts, not document pages. Shared by both
// Layout (the main container) and Navigation (the header) so the header goes
// edge-to-edge with the layout below; if the two ever diverge the logo/avatar
// drift out of line with the panels (GEN-5698). Orders render the same
// CaseWorkspace as cases, so both prefixes must be listed here.
export const FULL_BLEED_PREFIXES = ['/cases/', '/orders/']

export function isFullBleedPath(pathname: string): boolean {
  return FULL_BLEED_PREFIXES.some((p) => pathname.startsWith(p))
}
